import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Immutable from "immutable";
import NumberFormat from "react-number-format";
import { stripCommas } from "lib/utils/numberFunctions";
import { getEntity } from "data/entity";

class SelectedAllocation extends React.Component {
  static propTypes = {
    allocation: PropTypes.instanceOf(Immutable.Map).isRequired,
    onSelectAllocation: PropTypes.func.isRequired,
    onAmountChange: PropTypes.func.isRequired,
    totalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  handleClick() {
    const { allocation, onSelectAllocation, totalAmount } = this.props;

    onSelectAllocation(allocation, false, totalAmount);
  }

  handleInput(values) {
    const { onAmountChange, allocation, totalAmount } = this.props;

    onAmountChange(allocation, stripCommas(values.value), totalAmount);
  }

  render() {
    const { allocation, currencySymbol } = this.props;

    return (
      <div className="cause-selected">
        <div className="pull-left circle-50">
          <img
            src={allocation.get("img")}
            className="full-h"
            alt={allocation.get("name")}
          />
        </div>
        <h3 aria-label={allocation.get("name")} className="cause-name--selected">
          {allocation.get("name")}
        </h3>
        {currencySymbol}&nbsp;
        <div className="flex-it">
          <div>
            <NumberFormat
              aria-label={allocation.get("name")}
              className="highlight-color-input-focus"
              thousandSeparator={false}
              allowNegative={false}
              displayType="input"
              type="text"
              value={allocation.get("amount") || ""}
              onValueChange={this.handleInput}
            />
          </div>
          <button
            data-testid="t-giving-form--Selecte-click-to-remove"
            aria-label="Click to remove"
            className="vote-button--remove"
            onClick={this.handleClick}>
            <i className="fa fa-times"></i>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const currentEntity = getEntity(state);

  return {
    currencySymbol: currentEntity.get("currency_symbol"),
  };
};

export default connect(mapStateToProps)(SelectedAllocation);
